import {
  ADD_DEPARTMENT,
  ADD_DEPARTMENT_FAILED,
  ADD_DEPARTMENT_SUCCEEDED,
  CLEAR_CREATED_DEPARTMENT,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_FAILED,
  DELETE_DEPARTMENT_SUCCEEDED,
  GET_DEPARTMENTS,
  GET_DEPARTMENTS_FAILED,
  GET_DEPARTMENTS_SUCCEEDED,
} from 'Redux/Types/DepartmentTypes'

const INITIAL_STATE = {
  records: [],
  loading: false,
  createdDepartment: {},
  recordsFetched: false,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ADD_DEPARTMENT:
      return {
        ...state,
        loading: true,
        createdDepartment: {},
      }
    case ADD_DEPARTMENT_FAILED:
      return {
        ...state,
        loading: false,
      }
    case CLEAR_CREATED_DEPARTMENT:
      return {
        ...state,
        createdDepartment: {},
      }
    case ADD_DEPARTMENT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        createdDepartment: payload,
        records: [
          ...state.records,
          {
            ...payload,
            value: { name: payload.value, id: payload.tagValueId },
          },
        ],
      }

    case DELETE_DEPARTMENT:
      return {
        ...state,
        loading: true,
      }
    case DELETE_DEPARTMENT_FAILED:
      return {
        ...state,
        loading: false,
      }
    case DELETE_DEPARTMENT_SUCCEEDED:
      return {
        ...state,
        loading: false,
        records: state.records.filter((record) => record.tagSetId !== payload),
      }

    case GET_DEPARTMENTS:
      return {
        ...state,
        loading: true,
        recordsFetched: false,
      }
    case GET_DEPARTMENTS_FAILED:
      return {
        ...state,
        loading: false,
        recordsFetched: false,
      }
    case GET_DEPARTMENTS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        records: payload,
        recordsFetched: true,
      }

    default:
      return state
  }
}
